import React from "react";
import {
  Grid,
  GridItem,
  Icon,
  SimpleGrid,
  Text,
  VStack
} from "@chakra-ui/react";
import { AiOutlineUser } from "react-icons/ai";
import { BiBuildings, BiEnvelope } from "react-icons/bi";
import { IoKeyOutline } from "react-icons/io5";
import { IconType } from "react-icons/lib";

import { User, UserRole } from "types/user";
import { useUser } from "context/user";
import { AvatarIcon, Card } from "components";
import UserActions from "./AdminUserActions";
import { Callback } from "types";

interface InfoDisplayProps {
  info: string;
  icon: IconType;
}

const InfoDisplay: React.FC<InfoDisplayProps> = ({
  info,
  icon
}: InfoDisplayProps) => (
  <GridItem>
    <Icon as={icon} mr={1} />
    {info}
  </GridItem>
);

interface Props {
  user: User;
  saveUser: Callback;
  deleteUser: Callback;
}

const AdminUserRow: React.FC<Props> = ({
  user,
  saveUser,
  deleteUser
}: Props) => {
  const { user: actor } = useUser()!;
  const { first_name, last_name, username, email, organization, privs } = user;
  return (
    <Card>
      <Grid gap={5} templateColumns="fit-content(100%) 1fr fit-content(100%)">
        <AvatarIcon
          size="md"
          name={first_name ? `${first_name} ${last_name}` : username}
        />
        <VStack alignItems="flex-start">
          <Text fontSize="2xl">
            {first_name ? `${first_name} ${last_name}` : username}
          </Text>
          <SimpleGrid gap={3} columns={{ md: 2, lg: 4 }} width="full">
            {username && <InfoDisplay info={username} icon={AiOutlineUser} />}
            {email && <InfoDisplay info={email} icon={BiEnvelope} />}
            {privs && (
              <InfoDisplay info={UserRole[privs]} icon={IoKeyOutline} />
            )}
            {actor.privs > UserRole.OrgAdmin && organization && (
              <InfoDisplay
                info={organization.displayName || ""}
                icon={BiBuildings}
              />
            )}
          </SimpleGrid>
        </VStack>
        <UserActions user={user} saveUser={saveUser} deleteUser={deleteUser} />
      </Grid>
    </Card>
  );
};

export default AdminUserRow;
